import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import { SearchAPI } from "../api/searchApi";

interface SearchResult {
  uniqueId: string;
  code: string;
  brandName: string;
  name: string;
}

const SearchByPcodePage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [query, setQuery] = useState("");
  const [results, setResults] = useState<SearchResult[]>([]);
  const [loading, setLoading] = useState(false);
  const [searchCompleted, setSearchCompleted] = useState(false);
  const navigate = useNavigate();

  // Получаем pcode из URL
  useEffect(() => {
    const pcode = searchParams.get("pcode") || "";
    setQuery(pcode);
  }, [searchParams]);

  // Поиск по pcode
  useEffect(() => {
    const fetchProducts = async () => {
      if (!query.trim()) {
        setResults([]);
        setSearchCompleted(false);
        return;
      }
      setLoading(true);
      setSearchCompleted(false);
      try {
        const data = await SearchAPI.getProducts(query);
        setResults(data);
      } catch (error) {
        setResults([]);
      } finally {
        setLoading(false);
        setSearchCompleted(true);
      }
    };
    fetchProducts();
  }, [query]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setQuery(e.target.value);
    setSearchParams({ pcode: e.target.value });
  };

  return (
    <div className="flex flex-col items-center w-full min-h-[60vh] py-10 px-2">
      <div className="w-full max-w-xl mb-8">
        <div className="flex items-center gap-2 border rounded-lg px-3 py-2 bg-white shadow">
          <Search className="size-4 shrink-0 text-muted-foreground" />
          <input
            className="w-full bg-transparent text-base placeholder:text-muted-foreground focus-visible:outline-none"
            placeholder="Артикул детали"
            autoComplete="off"
            spellCheck="false"
            value={query}
            onChange={handleInputChange}
          />
        </div>
      </div>
      <div className="w-full max-w-xl">
        {loading && <p className="text-center text-muted-foreground">Загрузка...</p>}
        {searchCompleted && !loading && results.length === 0 && (
          <p className="text-center text-muted-foreground">Ничего не найдено</p>
        )}
        {!loading && results.length > 0 && (
          <div className="flex flex-col gap-2">
            {results.map((item) => (
              <div
                key={item.uniqueId}
                className="rounded-lg px-2 py-2 text-sm border hover:bg-gray-100 cursor-pointer"
                onClick={() => navigate(`/product?part_id=${item.uniqueId}`)}
              >
                <div className="flex flex-row items-center gap-3">
                  <p className="basis-1/6 truncate text-stone-700/50">{item.code}</p>
                  <p className="basis-2/4 truncate">{item.brandName}</p>
                  <p className="basis-2/4 text-right truncate text-stone-700/25">{item.name}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchByPcodePage; 